import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ITicketListResponse } from '../ticket-list-response';
import { ticketListResponseSchema } from '../ticket-list-response';

export async function listAllTicketsApi(): Promise<IValidatedResponse<ITicketListResponse>> {
  return getRequest<ITicketListResponse>({
    path: '/sys/ticket',
    schema: ticketListResponseSchema,
  });
}
